export default __webpack_public_path__ + "static/media/prejoinPage_camera.c623b09a.svg";